<template>
    <section class="why-we-like-this-book">
        <div class="row">
            <div class="col">
                <div v-if="showAllSummary" class="ql-editor" v-html="comment.summary" />
                <div v-else class="ql-editor" v-html="$options.filters.truncateText(comment.summary, summaryCharacterLimit)" />
            </div>
        </div>
        <div class="row mt-3">
            <div v-if="summaryLength > summaryCharacterLimit" class="col d-flex align-items-center text-primary">
                <img
                    class="mr-1"
                    src="@assets/img/book-insights/icons/plus.svg"
                    alt="+"
                    width="20px"
                >
                <a
                    class="text-primary"
                    href="javascript:void(0)"
                    @click="showAllSummary = !showAllSummary"
                >
                    <strong v-if="showAllSummary">View Less</strong>
                    <strong v-else> View More</strong>
                </a>
            </div>
            <div v-if="!isEmpty(comment.collaborator) && comment.collaborator.id" class="col-auto">
                <person-role-pill :credit="comment" />
            </div>
        </div>
    </section>
</template>

<script>

import _isEmpty from "lodash/isEmpty";

export default {
    name: "BookInsightComment",
    components: {
        personRolePill: () => import(/* webpackChunkName: "person-role-pill"*/ "@c/books-insights/person-role-pill")
    },
    props: {
        comment: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showAllSummary: false,
            summaryCharacterLimit: 350
        }
    },
    computed: {
        summaryLength() {
            return this.comment.summary.length;
        }
    },
    methods: {
        isEmpty: _isEmpty
    }
}
</script>
